<template>
	<v-card>
		<egranty-section-divider
			icon="receipt"
			:text="'Dokumenty finansowe projektu '.concat(projectData.title ? projectData.title : '')"
		/>
		<br>
		<v-card-title>
			<h2>Dokument &emsp; {{invoice.documentNumber}} &emsp; ({{ invoice.documentName }})</h2>
		</v-card-title>

		<invoice-form
			:invoice="invoice"
			ref="form"
			primary-button-caption="Zapisz"
			@primary-action="update"
			:loading="loading">
		</invoice-form>
	</v-card>
</template>

<script>
	import {Invoice} from "../../../api/generated/Invoice";
	import InvoiceForm from "./components/InvoiceForm";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import {Project} from "../../../api/generated/Project";

	export default {
		name: "InvoiceEditView",

		components: {EgrantySectionDivider, InvoiceForm},

		data() {
			return {
				invoice: {
					id: this.$route.params.invoiceId,
					documentName: "",
					documentNumber: "",
					costsSum: 0,
					paymentDates: [],
					actionCosts: [],
				},
				projectData: {},
				loading: false
			};
		},

		created() {
			Invoice.get(this, this.invoice.id, success => {
				this.invoice = success;
				Project.get(this, this.invoice.projectId, response => this.projectData = response);
			}, error => {
				this.$messagesBus.$emit("error", "Nie udało się załadować faktury", error);
			});
		},


		methods: {
			async update(invoice) {
				if(!this.loading){
				this.loading = true;
				if (await this.$refs.form.validate()) {
					Invoice.put(this, invoice, success => {
						this.$messagesBus.$emit("success", "Pomyślnie zapisano dokument", success);
						this.$router.go(-1);
					}, error => {
						this.loading = false;
						this.$messagesBus.$emit("error", "Nie udało się zapisać dokumentu", error);
					});
				} else {
					this.loading = false;	
				}
			}
			},
		},
	};
</script>

<style scoped>

</style>
